// import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from './AuthSelectors'; // import { isAppAuthSelector } from './ConfigSelectors';

export const allPromotionsSelector = ({
  promotions
}) => promotions;
export const allProductsSelector = ({
  abstractedProducts: {
    productMap
  }
}) => productMap;
export const skuMapSelector = ({
  abstractedProducts: {
    skuMap
  }
}) => skuMap;
export const apiNameToProductIdSelector = ({
  abstractedProducts: {
    apiNameToProductId
  }
}) => apiNameToProductId;

const productLineLevelToProductIdSelector = ({
  abstractedProducts: {
    productLineLevelToProductId
  }
}) => productLineLevelToProductId;

export const requiredOnboardingSelector = state => {
  const {
    requiredOnboarding
  } = state;
  return requiredOnboarding;
};
export const productInventorySelector = ({
  productInventory
}) => productInventory;
export const featuresSelector = ({
  features
}) => features;
export const compareSelector = ({
  compare
}) => compare;
export const businessObjectivesSelector = ({
  businessObjectives
}) => businessObjectives;
export const productDataSelector = createSelector([allProductsSelector, skuMapSelector, apiNameToProductIdSelector, productLineLevelToProductIdSelector], (productMap, skuMap, apiNameToProductId, productLineLevelToProductId) => ({
  productMap,
  skuMap,
  apiNameToProductId,
  productLineLevelToProductId
}));

const _customerCurrencyCodeSelector = ({
  customerCurrencyCode
}) => customerCurrencyCode;

const _activeCurrencySelector = state => {
  const {
    activeCurrencyCode
  } = state;

  const customerCurrencyCode = _customerCurrencyCodeSelector(state);

  if (customerCurrencyCode) {
    return customerCurrencyCode;
  }

  if (!CurrencyCodes[activeCurrencyCode]) return CurrencyCodes.USD;
  return activeCurrencyCode;
};

export const gatesSelector = state => {
  if (isAppAuthSelector(state)) {
    const {
      auth: {
        gates,
        user: {
          scopes = []
        }
      }
    } = state;
    return [...gates, ...scopes];
  }

  const {
    publicFeatureFlags
  } = state;
  const featureFlagKeys = Object.keys(publicFeatureFlags);
  return featureFlagKeys.filter(key => {
    return publicFeatureFlags[key] === true;
  });
};
export const transformState = createSelector([productDataSelector, allPromotionsSelector, _activeCurrencySelector, requiredOnboardingSelector, gatesSelector, featuresSelector, compareSelector, productInventorySelector, businessObjectivesSelector], (productData, promotions, currencyCode, requiredOnboarding, gates, features, compare, productInventory, businessObjectives) => ({
  productData,
  promotions,
  currencyCode,
  requiredOnboarding,
  gates,
  features,
  compare,
  productInventory,
  businessObjectives
}));
export const usePricingLibSelector = selector => useAppSelector(state => selector(transformState(state)));